import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, message, Spin } from "antd";
// Chemin direct : babel-plugin-import (config-overrides.js, style: true) réécrirait { theme } en antd/es/theme/style, inexistant
import theme from "antd/es/theme";

import MyTreeSidebar from "../TreeSidebar/";
import { initTree } from "../../store/actions/treeAction";
import { etapeTitleTree } from "../../utils/tools";

// Ne garde que les branches todo contenant des requêtes (nœuds avec etape_id).
// Attention : filtre item.children en place, donc mute les objets du store (dette connue).
const checkTodo = (newTree, item) => {
  item.children?.forEach((child) => {
    newTree = checkTodo(newTree, child);
  });
  if (item.todo && item.children?.some((child) => child.hasOwnProperty("etape_id"))) {
    item.children = item.children?.filter((child) => child.hasOwnProperty("etape_id"));
    newTree.push(item);
  }
  return newTree;
};

const buildTree = (source, todo) => {
  let tree = [];

  source?.forEach((i) => {
    i.title = etapeTitleTree(i);

    i.children &&
      i.children.forEach((j) => {
        j.title = etapeTitleTree(j);

        j.children &&
          j.children.forEach((k) => {
            k.title = etapeTitleTree(k);

            k.children &&
              k.children.forEach((l) => {
                l.title = etapeTitleTree(l);
              });
          });
      });
    if (todo) {
      tree = checkTodo(tree, i);
    } else tree.push(i);
  });

  return tree;
};

// Fond opaque + zIndex : l'arbre ne doit pas être visible au-dessus ni derrière la case en défilant.
// Pleine largeur comme l'en-tête du drawer : marge négative = padding latéral du corps (paddingLG antd, 24px)
const todoBarStyle = {
  position: "sticky",
  top: 0,
  zIndex: 1,
  background: "#fff",
  margin: "0 -24px",
  padding: "16px 24px",
};

// Arbre des étapes du parcours client, affiché dans l'AppDrawer.
// Rechargé à chaque ouverture du drawer (open passe à true).
const ParcoursClientTree = ({ open, handleSelectRequete }) => {
  const dispatch = useDispatch();
  // Bordure basse identique à celle de l'en-tête du drawer (colorSplit)
  const { token } = theme.useToken();
  const utilisateur = useSelector((state) => state.utilisateur.data);
  const treeData = useSelector((state) => state.tree.data);

  const [todo, setTodo] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    setLoading(true);
    dispatch(initTree(utilisateur.utilisateur_id))
      .catch(() => message.error("Erreur lors du chargement du parcours client"))
      .finally(() => setLoading(false));
  }, [open, dispatch, utilisateur.utilisateur_id]);

  const tree = useMemo(() => buildTree(treeData, todo), [treeData, todo]);

  return (
    <Spin spinning={loading}>
      {/* Sticky dans le corps du drawer ; .app-drawer-body n'a pas de padding haut (App.css), c'est la barre qui le porte */}
      <div style={{ ...todoBarStyle, borderBottom: `1px solid ${token.colorSplit}` }}>
        <Checkbox checked={todo} onChange={(e) => setTodo(e.target.checked)}>
          Étapes Todo
        </Checkbox>
      </div>
      {/* isolation : confine les z-index internes du Tree (traits showLine en z-index 1) sous la barre sticky.
          paddingTop = padding bas de la barre : bordure centrée entre la case et le premier nœud */}
      <div style={{ isolation: "isolate", paddingTop: 16 }}>
        {tree.length > 0 && (
          <MyTreeSidebar treeEtapes={tree} handleSelectRequete={handleSelectRequete} />
        )}
      </div>
    </Spin>
  );
};

export default ParcoursClientTree;
